import { Component, input } from '@angular/core';

@Component({
  selector: 'app-reset-password-error',
  imports: [],
  templateUrl: './reset-password-error.html',
  styleUrl: './reset-password-error.scss',
})
export class ResetPasswordError {
  errorTitle = input('Something went wrong');
  errorMessage = input<string | null>('Please try again later.');
}
